/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React from 'react'
import {Link} from 'react-router-dom'
import {getEncryptedRoute, limitLength} from '../../../../reusable'
import {KTIcon} from '../../../helpers'
import { Tr } from '../../../i18n/Tr'

type Props = {
  className: string
  color: string
  vehicleId: string
  vehicleName: string
  image: string
  maxPeople: string
  carCategory: string
  mileage: string
  progress: string
  deleteCar?: any
  editModalOpen?: any
  showDelete?: any
  showEdit?: any
  menuId: any
}

const MixedWidget26: React.FC<Props> = ({
  
  className,
  color,
  vehicleId,
  vehicleName,
  image,
  maxPeople,
  carCategory,
  mileage,
  progress,
  deleteCar,
  editModalOpen,
  showDelete,
  showEdit,
  menuId,
}) => {
  let t = Tr()
  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Heading */}
        <div className='d-flex flex-stack'>
          {/* begin:Info */}
          <div className='d-flex align-items-center'>
            {/* begin:Image */}
            <div className='symbol symbol-60px me-5'>
              <span className={clsx(`symbol-label`, `bg-${color}-light`)}>
                <img src={image} className='h-55px w-100 rounded align-self-center' alt='' />
              </span>
            </div>
            {/* end:Image */}

            {/* begin:Title */}
            <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
             
              <Link
                to={getEncryptedRoute('../vehicleoverview/' , {menuId : menuId})}
                state={{vehicleId: vehicleId}}
                className='text-dark fw-bold text-hover-primary fs-5'
              >
                {limitLength(vehicleName, 22)}
              </Link>

              <span className='badge badge-light-success me-auto mt-1'>{carCategory}</span>
            </div>
            {/* end:Title */}
          </div>
          {/* begin:Info */}

          {/* begin:Menu */}
          <div className='ms-1'>
            {editModalOpen && (
           <>
            {showEdit ?  <button
                onClick={() => editModalOpen(vehicleId)}
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='notepad-edit' className='fs-2' />
              </button> :""}
           </>
            )}
           {showDelete ? <button
              onClick={() => deleteCar(vehicleId)}
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='trash-square' className='fs-2' />
            </button> :''}
          </div>
          {/* end::Menu */}
        </div>
        {/* end::Heading */}

        {/* begin:Stats */}
        <div className='d-flex flex-column w-100 mt-12'>

          <div className='progress h-5px w-100'>
            <div
              className={`progress-bar bg-${color}`}
              role='progressbar'
              style={{width: progress}}
            ></div>
          </div>
        </div>
        {/* end:Stats */}

        {/* begin:Team */}
        <div className='d-flex flex-column mt-10'>
          <div className='text-dark me-2 fw-bold pb-0'>{t("No. Of Seats")}</div>
          <span className='text-muted fw-semibold mb-5'>{maxPeople}</span>
          <div className='text-dark me-2 fw-bold pb-1'>{t("Mileage")}</div>
          <span className='text-muted fw-semibold'>{mileage}</span>
        </div>
        {/* end:Team */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {MixedWidget26}
